import CustomLabel from '@/components/custom-label';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { css } from '@emotion/react';
import { Button, Form, Input, Space, Typography } from 'antd';
import {
  getListGroupFood,
  updateGroupFood,
  watchFoodLoading
} from '@/redux/slices/food.slice';

type FoodGroupEditModalProps = {
  group: DetailGroupFood;
  onCancel: () => void;
};

export const FoodManagementGroupEditModal = ({
  group,
  onCancel
}: FoodGroupEditModalProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(watchFoodLoading);

  const onFinish = async (values: any) => {
    const body: any = {
      ID: group.id,
      NAME: values.name,
      QUANTITY_FOOD: group.quantityFood
    }
    await dispatch(updateGroupFood(body));
    await dispatch(getListGroupFood());
    onCancel();
  };

  return (
    <Form form={form} css={containerStyles} onFinish={onFinish}>
      <Typography.Title css={titleStyles} level={5}>
        Chỉnh sửa nhóm thực phẩm
      </Typography.Title>

      <Form.Item
        name='name'
        label={<CustomLabel text='Tên nhóm thực phẩm' isRequired={true} />}
        rules={[
          { required: true, message: 'Vui lòng nhập tên nhóm thực phẩm!' }
        ]}
        initialValue={group && group.name}
      >
        <Input placeholder='Nhập tên nhóm thực phẩm' />
      </Form.Item>

      <Form.Item>
        <Space css={groupButtonStyles}>
          <Button type='default' size='large' onClick={onCancel}>
            Hủy
          </Button>
          <Button type='primary' size='large' htmlType='submit' loading={loading}>
            Lưu
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

const containerStyles = css`
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .ant-form-item {
    .ant-form-item-label {
      display: flex;
      align-items: center;
      margin-right: 2rem;
      text-align: start;

      label {
        &::after,
        &::before {
          display: none !important;
        }
      }
    }
    .ant-form-item-control-input {
      .ant-input {
        font-size: 14px !important;
        padding: 0.8rem 1.2rem !important;
      }
    }

    .ant-form-item-control-input-content .ant-input {
      height: 3.2rem !important;
    }
  }
`;

const titleStyles = css`
  margin-bottom: 1.6rem !important;
  line-height: 3.2rem !important;
`;

const groupButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  button {
    padding: 1rem 4rem;
  }
`;